import {
  Home, Shield, FileText, Globe, Mail, HelpCircle, Layout, Code, Image, Video,
  List, Columns, Type, Minus, MoveVertical, Quote, Star,
} from 'lucide-react';

/** Default pages that should always exist in the CMS — used by the
 *  "Initialize default pages" button on the Pages tab. */
export const DEFAULT_PAGES = [
  { slug: 'home',            title: 'Home Page',         icon: Home,       description: 'Landing page with hero, features, and CTA sections' },
  { slug: 'privacy-policy',  title: 'Privacy Policy',    icon: Shield,     description: 'Privacy policy page content' },
  { slug: 'terms-of-service',title: 'Terms of Service',  icon: FileText,   description: 'Terms of service page content' },
  { slug: 'about',           title: 'About Us',          icon: Globe,      description: 'About the company page' },
  { slug: 'contact',         title: 'Contact Us',        icon: Mail,       description: 'Contact information and form' },
  { slug: 'faq',             title: 'FAQ',               icon: HelpCircle, description: 'Frequently asked questions' },
];

/** All supported block-types the user can pick from in the section editor. */
export const SECTION_TYPES = [
  { type: 'hero',         label: 'Hero',              icon: Layout },
  { type: 'content',      label: 'Rich Text',         icon: FileText },
  { type: 'html',         label: 'Custom HTML',       icon: Code },
  { type: 'image',        label: 'Image',             icon: Image },
  { type: 'video',        label: 'Video',             icon: Video },
  { type: 'gallery',      label: 'Gallery',           icon: Image },
  { type: 'features',     label: 'Features',          icon: List },
  { type: 'columns',      label: 'Columns',           icon: Columns },
  { type: 'cta',          label: 'CTA',               icon: Type },
  { type: 'faq',          label: 'FAQ',               icon: HelpCircle },
  { type: 'testimonials', label: 'Testimonials',      icon: Quote },
  { type: 'pricing',      label: 'Pricing (Inline)',  icon: Star },
  { type: 'plans_grid',   label: 'Plans Grid (Live)', icon: Star },
  { type: 'divider',      label: 'Divider',           icon: Minus },
  { type: 'spacer',       label: 'Spacer',            icon: MoveVertical },
];

/** Blank section form — used when the user creates a brand-new block. */
export const EMPTY_SECTION_FORM = {
  section_type: 'content',
  title: '',
  subtitle: '',
  content: '',
  html: '',
  image_url: '',
  image_caption: '',
  image_link: '',
  video_url: '',
  columns: [],
  columns_count: 2,
  background_image: '',
  background_position: 'center center',
  background_attachment: 'scroll',
  background_size: 'cover',
  overlay_color: '#000B18',
  overlay_opacity: 0.8,
  bg_color: '',
  padding_y: 'default',
  max_width: 'default',
  rounded: true,
  text_align: 'left',
  title_color: '',
  text_color: '',
  cta_label: '',
  cta_url: '',
  cta_secondary_label: '',
  cta_secondary_url: '',
  is_visible: true,
  order: 0,
  items: [],
  settings: {},
};
